import axios from 'axios';
import { postApi, getApi, deleteApi } from './_apihelper';

// Create a custom report
export const CreateCustomReport = (data) =>
  postApi(
    '', // Empty endpoint since full URL is in base
    data,
    process.env.REACT_APP_CUSTOM_REPORTS
  );

// Get all custom reports for a user
export const GetCustomReports = (createdBy, page = 1, limit = 50) =>
  getApi(
    `?createdBy=${createdBy}&page=${page}&limit=${limit}`,
    process.env.REACT_APP_CUSTOM_REPORTS
  );

// Get custom report by ID
export const GetCustomReportById = (id) =>
  getApi(`/${id}`, process.env.REACT_APP_CUSTOM_REPORTS);

// Delete a custom report
export const DeleteCustomReport = (id, createdBy) =>
  deleteApi(
    `/${id}?createdBy=${createdBy}`,
    {},
    process.env.REACT_APP_CUSTOM_REPORTS
  );

// Download a custom report by S3 key
export const DownloadCustomReport = (key) =>
  axios.post(
    `${process.env.REACT_APP_CUSTOM_REPORTS}/download`,
    { key },
    {
      responseType: 'blob',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
      },
    }
  );
